import { Rect } from "yfiles";
import { NODE_DEFAULT_SIZE } from "../../constants";
export default (graphComponent) => new Rect(graphComponent.center.x, graphComponent.center.y, NODE_DEFAULT_SIZE.width, NODE_DEFAULT_SIZE.height);
